// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2C2kT","question":"styles_question__3XWns","inputVisibleButton":"styles_inputVisibleButton__39nIo","note":"styles_note__1-tz4"};